import { render, staticRenderFns } from "./VersionEvent.vue?vue&type=template&id=7e41fb98&scoped=true"
import script from "./VersionEvent.vue?vue&type=script&lang=js"
export * from "./VersionEvent.vue?vue&type=script&lang=js"
import style0 from "./VersionEvent.vue?vue&type=style&index=0&id=7e41fb98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e41fb98",
  null
  
)

export default component.exports